module.exports = __webpack_public_path__ + "static/media/smileyface.37a868a3.svg";